module.exports = function ($stateProvider) {
    const _ = require('lodash'),
        authenticationHandler = require('./authentication-handler'),
        checkIfComingSoon = ['$state', 'Settings', ($state, settings) => {
            if (!(settings.deliverySaver && settings.deliverySaver.isEnabled &&
                    settings.payment && settings.payment.enableDigitalPay)) {
                $state.go('shop.deliveryplus.comingsoon');
            }
        }];

    $stateProvider
        .state('shop.deliveryplus', {
            url: '/deliveryplus',
            resolve: {
                modules: [
                    '$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load('deliverysaver');
                    },
                ],
                navigationItems: ['InspirationService', function (inspirationService) {
                    return inspirationService.getNavigationItems();
                }],
                authMethod: ['ShopperService', shopperService =>
                    (shopperService.getAuthenticationMethod().then(response => response.AuthenticationMethod)),
                ],
            },
            onEnter: [
                '$state', '$q', 'LoginService', 'authMethod',
                _.partialRight(authenticationHandler, 'Please login to continue'),
            ],
            views: {
                'left-panel@shop': {
                    controller: [
                        'navigationItems', function (navigationItems) {
                            this.menuItems = navigationItems;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-inspiration-navigation ng-if="!$breakpoints.isInSmallFormat" menu-items="$ctrl.menuItems"></wow-inspiration-navigation>',
                },
                'center-panel@shop': {
                    controller: [
                        '$state', 'Settings', '$location', function ($state, settings, $location) {
                            if (!(settings.deliverySaver && settings.deliverySaver.isEnabled && settings.payment && settings.payment.enableDigitalPay)) {
                                $state.go('shop.deliveryplus.comingsoon');
                            } else {
                                $location.path(settings.deliverySaver.discoverPageUrl);
                            }
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-delivery-saver-plan-selection class=""></wow-delivery-saver-plan-selection>',
                },
            },
            data: {
                authenticate: true,
                pageMetadata: [
                    'PageMetadataService',
                    function (pageMetadataService) {
                        return pageMetadataService.getMetadata({
                            name: 'Delivery Plus | Woolworths',
                        });
                    },
                ],
            },
        })
        .state('shop.deliveryplus.comingsoon', {
            url: '/comingsoon',
            onEnter: ['$location', 'Settings', ($location, settings) => {
                if (settings.deliverySaver && settings.deliverySaver.isEnabled &&
                    settings.payment && settings.payment.enableDigitalPay) {
                    $location.path(settings.deliverySaver.discoverPageUrl);
                }
            }],
            views: {
                'center-panel@shop': {
                    template: '<wow-delivery-saver-coming-soon></wow-delivery-saver-coming-soon>',
                },
            },
        })
        .state('shop.deliveryplus.planselection', {
            url: '/planselection',
            onEnter: checkIfComingSoon,
            views: {
                'center-panel@shop': {
                    template: '<wow-delivery-saver-plan-selection class=""></wow-delivery-saver-plan-selection>',
                },
            },
        })
        .state('shop.deliveryplus.paymentsetup', {
            url: '/paymentsetup?planId',
            onEnter: checkIfComingSoon,
            views: {
                'center-panel@shop': {
                    template: '<wow-delivery-saver-payment-setup class=""></wow-delivery-saver-payment-setup>',
                },
            },
        })
        .state('shop.deliveryplus.confirmation', {
            url: '/confirmation?subscriptionId',
            views: {
                'center-panel@shop': {
                    template: '<wow-delivery-saver-confirmation class=""></wow-delivery-saver-confirmation>',
                },
            },
            params: {
                data: {},
            },
        })
        .state('shop.deliveryplus.paymentupdate', {
            url: '/paymentupdate',
            views: {
                'center-panel@shop': {
                    template: '<wow-delivery-saver-payment-update class=""></wow-delivery-saver-payment-update>',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/deliverysaver.js